import React, { useEffect, useRef, useState } from 'react';
import { Form, Button, Input } from 'antd';
import Box from '../../../../../components/Box';
import SelectTagsInput from './SelectTagsInput';
import FilterModal, { FilterModalRef } from './FilterModal';
import { CAMPAIGN_GROUP_TYPE } from './customerFilterConstant';
import accountApis from '../../../../../services/accountApis';
import {
  CustomerType,
  ICustomerByGroupV2ResItem,
  ICustomersByGroupV2Params,
} from '../../../../../services/apisType';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import IcFilter from './IcFilter';

const GroupFilterSpecial = () => {
  const { id = '' } = useParams();
  const form = Form.useFormInstance();
  const modalFilter = useRef<FilterModalRef>(null);
  const [loading, setLoading] = useState(false);

  const checkValidateSearchCustomer = () => {
    const values = form?.getFieldsValue();
    if (values?.filterCustomerGroup?.[0] && values?.totalSend) {
      return true;
    }
    const formSetError = [
      ...(!values?.filterCustomerGroup?.[0]
        ? [
            {
              name: 'filterCustomerGroup',
              errors: ['Please select at least one option'],
            },
          ]
        : []),
      ...(!values?.totalSend
        ? [
            {
              name: 'totalSend',
              errors: ['Please enter customer phone/name'],
            },
          ]
        : []),
    ];
    form.setFields(formSetError);
    return false;
  };

  const getGroupType = (filterValue: string) => {
    const groupType = Object.values(CAMPAIGN_GROUP_TYPE).find((type) =>
      filterValue.startsWith(`${type}_`)
    );
    return groupType;
  };
  const getValues = (filterValue: string) => {
    const groupType = Object.values(CAMPAIGN_GROUP_TYPE).find((type) =>
      filterValue.startsWith(`${type}_`)
    );
    if (!groupType) return '';
    return filterValue.replace(`${groupType}_`, '');
  };
  const handleSearch = async () => {
    const isValid = checkValidateSearchCustomer();
    if (!isValid) return;
    const values = form?.getFieldsValue();

    if (values?.filterCustomerGroup?.[0]) {
      try {
        setLoading(true);
        const groupType = getGroupType(values?.filterCustomerGroup?.[0]);
        const valuesFilter = values.filterCustomerGroup?.map((item: string) => getValues(item));
        const _body: ICustomersByGroupV2Params = {
          groupType: groupType || '',
          totalSend: values.totalSend || 0,
          ...(groupType === CAMPAIGN_GROUP_TYPE.AVG_VISIT && { avgGroup: valuesFilter }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH && { birthdayGroup: valuesFilter }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.REWARD_GROUP && { rewardGroup: valuesFilter }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.REVIEW_GROUP && { starType: valuesFilter }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT && { visitType: valuesFilter }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN && {
            totalDays: parseInt(valuesFilter?.[0]) || 0,
          }),
          ...(groupType === CAMPAIGN_GROUP_TYPE.VISITED_WITHIN && {
            totalDays: parseInt(valuesFilter?.[0]) || 0,
          }),
        };
        const response = await accountApis.getCustomersBySpecialFilter(id, _body);
        if (response.status === 200) {
          const data: ICustomerByGroupV2ResItem[] = response.data.data;
          const dataConvert: CustomerType[] = data?.map((o) => ({
            customerId: o.id,
            customerName: o.name,
            customerPhone: o.phone,
            email: o.email,
            birthday: o.birthday,
            point: o.point,
            lastVisitedDate: o.lastVisitedDate,
            amountSpent: o.amountSpent,
          }));
          form.setFieldsValue({ customers: dataConvert });
        } else {
          form.setFieldsValue({ customers: [] });
        }
      } catch (error) {
        form.setFieldsValue({ customers: [] });
      } finally {
        setLoading(false);
      }
    }
  };

  const showModalFilter = () => {
    const data = form?.getFieldsValue();
    modalFilter.current?.open(data?.filterCustomerGroup);
  };

  const handleChangeTotalSend = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) {
      form.setFields([{ name: 'totalSend', errors: ['Please enter customer phone/name'] }]);
    } else {
      form.setFields([{ name: 'totalSend', value, errors: [] }]);
    }
  };

  useEffect(() => {
    return () => {
      form.resetFields(['filterCustomerGroup', 'totalSend']);
    };
  }, [form]);

  return (
    <Box display='flex' gap={1}>
      <Button onClick={showModalFilter} type='primary' size='large'>
        <Box display='flex' alignItems='center' style={{ gap: 8 }}>
          <IcFilter /> Filter
        </Box>
      </Button>
      <Box width='100%'>
        <FormItemStyled name={'filterCustomerGroup'}>
          <SelectTagsInput />
        </FormItemStyled>
      </Box>
      <Box width='400px'>
        <FormItemStyled name={'totalSend'}>
          <Input
            size='large'
            type='number'
            placeholder='Number of Customers'
            onChange={handleChangeTotalSend}
          />
        </FormItemStyled>
      </Box>
      <Button onClick={handleSearch} size='large' type='primary' loading={loading}>
        Search
      </Button>
      <FilterModal ref={modalFilter} formFilter={form} />
    </Box>
  );
};

export default GroupFilterSpecial;

const FormItemStyled = styled(Form.Item)`
  margin-bottom: 0;
`;
